// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uORX","colBig":"styles_colBig__xJRxr","colSmall":"styles_colSmall__1zbXc","shopifyNameWrapper":"styles_shopifyNameWrapper__3VtX7"};